import type { FeedFilterOption, FeedViewPayload } from "../types/feed.ts"

export function feedOptionToViewPayload(option: FeedFilterOption): FeedViewPayload {
  if (option === "recomendados") {
    return { selectedOption: option, order: "ASC", type: "MG" }
  }
  if (option === "recientes") {
    return { selectedOption: option, order: "DESC", type: "DATE" }
  }
  if (option === "Mostrar") {
    return { selectedOption: option, order: "DESC", type: "DATE" }
  }
  return { selectedOption: option }
}

export function exploreFilterLabel(option: FeedFilterOption): string {
  switch (option) {
    case "Mostrar":
      return "Mostrar"
    case "recientes":
      return "Todos (Recientes)"
    case "recomendados":
      return "Posteos más recomendados"
    case "productos":
      return "Solo Productos"
    case "servicios":
      return "Solo Servicios"
    case "posteos":
      return "Solo Posteos"
    case "propios":
      return "Mis Publicaciones"
    default:
      return "Mostrar"
  }
}
